import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import RecordProduct from "./RecordProduct.graphql";
import { products } from "../../modules/api";

export default function useRecordProduct(selector, product) {
    return useMutation(
        gql(RecordProduct),
        {
            client: products,
            variables: {
                origin: "brand",
                product,
                selector,
            },
        },
    );
}
